// TYPE GUARDS
export const isJoinMessage = (message) => message.type === "join";
export const isLeaveMessage = (message) => message.type === "leave";
export const isPeerMessage = (message) => message.type === "peer";
export const isErrorMessage = (message) => message.type === "error";
